import type * as React from "react";

import { IconType } from "../icon/IconType";
import { LinkButton } from "../Link";
import { Icon } from "../icon/Icon";
import { useTranslation } from "react-i18next";

interface ToggleButtonProps {
  isOpen: boolean;
  onToggle: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ isOpen, onToggle, className }) => {
  const { t } = useTranslation();

  const label = t(`searchPage.refinements.${isOpen ? "showLess" : "showMore"}`);
  const iconType = isOpen ? IconType.ChevronUp : IconType.ChevronDown;

  return (
    <LinkButton onClick={onToggle} className={className} iconBefore={<Icon type={iconType} />}>
      {label}
    </LinkButton>
  );
};

export default ToggleButton;
